module.exports = __webpack_public_path__ + "img/termine-aerzte.0ed26518.png";